import { IMetaDataList } from './types';

export const metaHeading = 'This article applies to:';

export const metaDataList: IMetaDataList[] = [
  {
    text: 'Product ',
    value: 'Checkpoint Classic,Accounting CS Client Access,Practical Law',
  },
  {
    text: 'Subject ',
    value: 'Research',
  },
  {
    text: 'Related ',
    value: 'checkpoint, research, practical law, pratical law',
  },
];
